import $http from '../http';
let complaintPath = '/tio/complain/v2/api/';

export const user = data => { // 处理组首页用户信息
    return $http({
        url: complaintPath + 'wxWork/getVisitor',
        data,
        method: 'POST'
    });
};
export const syntheticalWarningList = data => { // 综合预警列表
    return $http({
        url: complaintPath + 'newWorkbench/list/syntheticalWarning',
        data,
        method: 'POST'
    });
};
export const infoList = data => { // 搜索查询接口列表
    return $http({
        url: complaintPath + 'newWorkbench/list/infoList',
        data,
        method: 'POST'
    });
};
export const timeLimitList = data => { // 时限预警列表
    return $http({
        url: complaintPath + 'newWorkbench/list/timeLimit',
        data,
        method: 'POST'
    });
};
export const emergencyList = data => { // 投诉紧急程度列表
    return $http({
        url: complaintPath + 'newWorkbench/list/emergency',
        data,
        method: 'POST'
    });
};
export const getComplainStateDetailList = data => { // 投诉状态列表
    return $http({
        url: complaintPath + 'newWorkbench/list/complainState',
        data,
        method: 'POST'
    });
};
export const getComplainDealStateList = data => { // 投诉处理状态列表
    return $http({
        url: complaintPath + 'newWorkbench/list/complainDealState',
        data,
        method: 'POST'
    });
};
export const getDropDistributionList = data => { // 投诉落点分布列表
    return $http({
        url: complaintPath + 'newWorkbench/list/dropDistribution',
        data,
        method: 'POST'
    });
};
export const queryAllsyntheticalWarning = data => { // 获取综合预警投诉统计数据
    return $http({
        url: complaintPath + 'newWorkbench/workbench/syntheticalWarning',
        data,
        method: 'POST'
    });
};
export const queryAllemergency = data => { // 获取紧急程度投诉统计数据
    return $http({
        url: complaintPath + 'newWorkbench/workbench/emergency',
        data,
        method: 'POST'
    });
};
export const queryAlltimeLimit = data => { // 获取时限预警投诉统计数据
    return $http({
        url: complaintPath + 'newWorkbench/workbench/timeLimit',
        data,
        method: 'POST'
    });
};
export const trend = data => { // 近30天投诉趋势
    return $http({
        url: complaintPath + 'newWorkbench/workbench/trend',
        data,
        method: 'POST'
    });
};
export const getListRegion = data => { // 行政区域划分
    return $http({
        url: complaintPath + 'complaint/publicCondition/getAllRegion',
        data,
        method: 'POST'
    });
};
export const getComplainChannel = data => { // 获取投诉渠道
    return $http({
        url: complaintPath + 'complaint/publicCondition/getComplainChannel',
        data,
        method: 'POST'
    });
};
export const queryDetailInfo = data => { // 获取投诉详情
    return $http({
        url: complaintPath + 'qywx/details/info',
        data,
        method: 'POST'
    });
};
export const getCosSession = data => {
    return $http({
        url: complaintPath + 'fileUpload',
        data,
        method: 'POST'
    });
}

/**
 * 获取投诉待办数量【已废弃】
 * @param {*} data 
 * @returns 
 */
export const handleMessageCount = data => { // 获取待办统计
    return $http({
        url: complaintPath + 'handleMessageCount',
        data,
        method: 'POST'
    })
}

/**
 * 获取投诉待办数量
 * @param {*} data 
 * @returns 
 * @wiki https://www.tapd.cn/67427372/markdown_wikis/show/#1167427372001007463
 */
export const getNewhandleMessageCount = data => { // 获取待办统计
    return $http({
        url: complaintPath + '/complaint/todo/getWaitHandleNumber',
        data,
        method: 'GET'
    })
}

/**
 * 获取投诉待办列表【已废弃】
 * @param {*} data 
 * @returns 
 */
export const getWaitHandleList = data => { // 获取待办列表
    return $http({
        url: complaintPath + 'getWaitHandleList',
        data,
        method: 'POST'
    })
}
/**
 * 获取投诉待办列表
 * @param {*} data 
 * @returns
 * @wiki https://www.tapd.cn/67427372/markdown_wikis/show/#1167427372001007390
 */
export const getNewWaitHandleList = data => { // 获取待办列表
    return $http({
        url: complaintPath + '/complaint/todo/getWaitHandleList',
        params: data,
        method: 'GET'
    })
}
// 考核跳投诉列表
export const queryComplainList = data =>{
  return $http({
    url: complaintPath + 'penetrate/assessToComplain/list',
    data,
    method: 'POST'
  })
}

export default {
    user,
    infoList,
    syntheticalWarningList,
    timeLimitList,
    getComplainStateDetailList,
    getDropDistributionList,
    getComplainDealStateList,
    emergencyList,
    queryAllsyntheticalWarning,
    queryAllemergency,
    queryAlltimeLimit,
    trend,
    getListRegion,
    getComplainChannel,
    queryDetailInfo,
    getCosSession,
    handleMessageCount,
    getNewhandleMessageCount,
    getWaitHandleList,
    getNewWaitHandleList,
    queryComplainList
}
